<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="text-uppercase justify-center">Покупатели</v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="teal" class="white--text" :disabled="!selectedUsers.length" @click="exportToXls">
                            {{ $t('exportXLS') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
                <div class="py-3"></div>
                <users-filters :users-type="$store.state.clients.types.buyer"
                    @filter-change="filterChange"></users-filters>
                <div class="py-3"></div>
                <v-card>
                    <buyers-table :filters="filters" @load-error="onDataLoadError"></buyers-table>
                </v-card>
            </v-col>
        </v-row>
        <v-snackbar v-model="snackOpen" :color="snackColor" top>
            {{ snackText }}
            <template v-slot:action="{ attrs }">
                <v-btn text icon v-bind="attrs" @click="resetSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import { mapState } from 'vuex';
import BuyersTable from '../../../components/data-tables/buyers';
import UsersFilters from '../../../components/filters/UsersFilters';
import { MixinTableLoadSnack } from '../../../mixins';
import { ExportService } from '../../../services';

export default {
    name: 'Buyers',
    components: {
        BuyersTable,
        UsersFilters,
    },
    mixins: [MixinTableLoadSnack],
    data() {
        return {
            filters: {},
        }
    },
    computed: {
        ...mapState(['selectedUsers']),
    },
    methods: {
        filterChange(filters) {
            this.filters = filters;
        },
        exportToXls() {
            ExportService.buyers(this.selectedUsers.map(item => item.id));
            this.$store.commit('setSelectedUsers', []);
        },
    },
    beforeDestroy() {
        this.$store.commit('setSelectedUsers', []);
    }
};
</script>

<style scoped></style>
